// extracted by mini-css-extract-plugin
module.exports = {"slBuoyMapMarkers":"BuoyMapMarkers_slBuoyMapMarkers__V0HdL"};